class VariantImageChanger {
  constructor(section) {
    this.section = section;
    this.sectionId = section.getAttribute('data-section-id');
    this.tallLayout = section.getAttribute('data-tall-layout') === 'true';
    this.map = this.loadMap();
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  init() {
    if (!Object.keys(this.map).length) return;

    this.section.addEventListener('theme:variant:change', this.onVariantChange);

    const variantId = this.section.querySelector('[data-product-select]')?.value;
    if (variantId) this.focusVariantWhenReady(variantId);
  }

  usesFlickity() {
    return !this.tallLayout || window.innerWidth < window.theme.sizes.large;
  }

  focusVariantWhenReady(variantId) {
    if (!this.usesFlickity()) {
      this.focusVariant(variantId);
      return;
    }

    const slider = this.section.querySelector('[data-product-single-media-slider]');
    let attempts = 0;
    const maxAttempts = 20;

    const tryFocus = () => {
      const flkty = window.themeVendor?.Flickity?.data(slider);
      if (flkty?.isActive || attempts >= maxAttempts) {
        this.focusVariant(variantId);
        return;
      }

      attempts += 1;
      requestAnimationFrame(tryFocus);
    };

    tryFocus();
  }

  loadMap() {
    const mapEl = document.getElementById(`VariantMediaMap-${this.sectionId}`);
    if (!mapEl) return {};

    try {
      return JSON.parse(mapEl.textContent);
    } catch (error) {
      console.warn('VariantImageChanger: invalid media map JSON', error);
      return {};
    }
  }

  onVariantChange(event) {
    const variantId = event.detail?.variant?.id;
    if (variantId) this.focusVariant(variantId, { scroll: true });
  }

  focusVariant(variantId, { scroll = false } = {}) {
    const mediaId = this.map[String(variantId)];
    if (!mediaId) return;

    const slider = this.section.querySelector('[data-product-single-media-slider]');
    const slide = slider?.querySelector(`[data-id="${mediaId}"]`);
    if (!slide) return;

    const Flickity = window.themeVendor?.Flickity;
    const flkty = Flickity ? Flickity.data(slider) : null;

    if (flkty && flkty.isActive) {
      const slideIndex = [...slide.parentNode.children].indexOf(slide);
      if (slideIndex > -1) flkty.select(slideIndex);
      return;
    }

    this.switchMediaVisibility(mediaId);

    if (scroll && this.tallLayout && window.innerWidth >= window.theme.sizes.large) {
      const img = slide.querySelector('[data-product-image]');
      const target = img || slide;
      const header = document.querySelector('[data-header-height]');
      const offset = header ? header.getBoundingClientRect().height : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({ top, behavior: 'smooth' });
    }
  }

  switchMediaVisibility(mediaId) {
    const fullMediaId = `${this.sectionId}-${mediaId}`;
    const wrappers = this.section.querySelectorAll('[data-product-single-media-wrapper]');
    const selected = this.section.querySelector(
      `[data-product-single-media-wrapper][data-media-id="${fullMediaId}"]`
    );

    if (!selected) return;

    wrappers.forEach((el) => el.classList.add('media--hidden'));
    selected.classList.remove('media--hidden');
  }
}

function initVariantImageChanger() {
  document
    .querySelectorAll('[data-section-type="product-template"], [data-section-type="featured-product"]')
    .forEach((section) => new VariantImageChanger(section).init());
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantImageChanger);
} else {
  initVariantImageChanger();
}
